import { useRef, useState } from 'react';
import { api, errorMessage } from '../../shared/api/client';
import { Alert, Button } from '../../shared/ui/components';

/** Grabar (con el micrófono) o subir la reflexión en audio de un día del «Hoy». */
export function AudioRecorder({ churchId, day, hasAudio, onChange }: { churchId: string; day: string; hasAudio: boolean; onChange: () => void }) {
  const url = `/devotional/churches/${churchId}/daily/${day}/audio`;
  const [recording, setRecording] = useState(false);
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const rec = useRef<MediaRecorder | null>(null);
  const chunks = useRef<Blob[]>([]);
  const upload = async (file: File) => {
    setBusy(true);
    setError(null);
    try {
      await api.putFile(url, file);
      onChange();
    } catch (e) {
      setError(errorMessage(e));
    } finally {
      setBusy(false);
    }
  };
  async function start() {
    setError(null);
    try {
      const stream = await navigator.mediaDevices.getUserMedia({ audio: true });
      const r = new MediaRecorder(stream);
      chunks.current = [];
      r.ondataavailable = (e) => chunks.current.push(e.data);
      r.onstop = () => {
        stream.getTracks().forEach((t) => t.stop());
        const type = r.mimeType.split(';')[0] || 'audio/webm';
        void upload(new File(chunks.current, `reflexion.${type.includes('ogg') ? 'ogg' : type.includes('mp4') ? 'm4a' : 'webm'}`, { type }));
      };
      r.start();
      rec.current = r;
      setRecording(true);
    } catch {
      setError('No se pudo usar el micrófono. Revisa el permiso del navegador o sube un archivo.');
    }
  }
  function stop() {
    rec.current?.stop();
    setRecording(false);
  }
  return (
    <div className="audio-recorder">
      {error ? <Alert>{error}</Alert> : null}
      {hasAudio ? <audio controls preload="none" src={`/api${url}`} /> : null}
      <div className="actions actions--wrap">
        {typeof MediaRecorder !== 'undefined' ? (
          recording ? <Button onClick={stop}>⏹ Terminar grabación</Button> : <Button variant="secondary" busy={busy} onClick={() => void start()}>🎙 {hasAudio ? 'Grabar de nuevo' : 'Grabar reflexión'}</Button>
        ) : null}
        <label className="btn btn--ghost">
          Subir audio
          <input type="file" accept="audio/*" hidden onChange={(e) => { const f = e.target.files?.[0]; e.target.value = ''; if (f) void upload(f); }} />
        </label>
        {hasAudio ? <Button variant="ghost" busy={busy} onClick={() => void api.delete(url).then(onChange).catch((e) => setError(errorMessage(e)))}>Quitar audio</Button> : null}
      </div>
    </div>
  );
}
